module.exports = __webpack_public_path__ + "img/Artboard1.4f29b373.jpg";